import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../config/stripe';
import { auth } from '../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import PaymentMethodForm from '../components/PaymentMethodForm';
import { useWindowSize, BP } from '../hooks/useWindowSize';

function PaymentSetupPage() {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = width < BP.mobile;
  const [user, setUser] = useState(null);
  const [clientSecret, setClientSecret] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (!firebaseUser) {
        navigate('/');
        return;
      }
      setUser(firebaseUser);
    });

    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (!user) return;
    createSetupIntent();
  }, [user]);

  const createSetupIntent = async () => {
    try {
      console.log('Auth state:', auth.currentUser?.uid);
      console.log('ID token:', await auth.currentUser?.getIdToken());

      const functions = getFunctions(getApp());
      const createSetupIntentFn = httpsCallable(functions, 'createSetupIntent');
      const result = await createSetupIntentFn({});

      console.log('Setup intent created:', result.data);
      setClientSecret(result.data.clientSecret);
      setLoading(false);
    } catch (error) {
      console.error('Error creating setup intent:', error);
      setError(error.message);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem' }}>
        <div>Loading payment setup...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem' }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ color: '#dc2626', marginBottom: '1rem' }}>Error</h2>
          <p>{error}</p>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'hidden', maxWidth: '100vw' }}>
      {/* Content */}
      <div style={{ maxWidth: isMobile ? '90vw' : '600px', margin: isMobile ? '0 auto' : '2rem auto', padding: isMobile ? 0 : '0 1rem' }}>
        <div style={{
          backgroundColor: 'white',
          padding: isMobile ? '20px' : '2rem',
          borderRadius: '8px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>
            Payment Information
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '2rem' }}>
            Add a payment method to hire workers. You'll be charged $99 per successful hire.
          </p>

          {clientSecret && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <PaymentMethodForm />
            </Elements>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentSetupPage;